module.exports = require("botpress");


//////////////////
// WEBPACK FOOTER
// external "botpress"
// module id = 22
// module chunks = 0